// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rXfBY","type":"styles_type__1x2CG","choices":"styles_choices__1Z1Ha"};